import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { uerWorkOrderChangeLastSeasonSelectionListGql } from '../WorkOrderChangeQueries';

const requestId = 'uerWorkOrderChangeLastSeasonSelectionList';

export const useUerWorkOrderChangeLastSeasonSelectionList = (workOrderChangeId?: number) => {
    const variables = useMemo(() => ({ workOrderChangeId }), [workOrderChangeId]);

    const [uerWorkOrderChangeLastSeasonSelectionListReset] = useResetStoreData({ requestId });

    const [uerWorkOrderChangeLastSeasonSelectionListData, uerWorkOrderChangeLastSeasonSelectionListStatus] = useRequest(
        {
            requestId,
            query: uerWorkOrderChangeLastSeasonSelectionListGql,
            variables,
            withEffect: !!workOrderChangeId,
        },
    );

    useEffect(() => {
        uerWorkOrderChangeLastSeasonSelectionListReset(undefined);
    }, [uerWorkOrderChangeLastSeasonSelectionListReset]);

    return {
        uerWorkOrderChangeLastSeasonSelectionListData,
        uerWorkOrderChangeLastSeasonSelectionListStatus,
    };
};
